import React, { useState, createContext, useEffect } from 'react';

export const WindowSizeContext = createContext({ width: -1, height: -1 });

const isClient = typeof window === 'object';

function getSize(): { width: number; height: number } {
  return {
    width: isClient ? window.innerWidth : -1,
    height: isClient ? window.innerHeight : -1,
  };
}

export const WindowSizeProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [windowSize, setWindowSize] = useState(getSize());

  useEffect(() => {
    if (!isClient) {
      return;
    }
    setWindowSize(getSize());

    const handleResize = () => {
      setWindowSize(getSize());
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <WindowSizeContext.Provider value={windowSize}>
      {children}
    </WindowSizeContext.Provider>
  );
};
